import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_6e56adae from 'nuxt_plugin_plugin_6e56adae' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_c903701a from 'nuxt_plugin_bootstrapvue_c903701a' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_appplugin_2375e480 from 'nuxt_plugin_appplugin_2375e480' // Source: ../../@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_1e0439cf from 'nuxt_plugin_configplugin_1e0439cf' // Source: ../../@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_libplugin723a6a30_42d54637 from 'nuxt_plugin_libplugin723a6a30_42d54637' // Source: ./lib.plugin.723a6a30.js (mode: 'all')
import nuxt_plugin_gtm_7e86d59a from 'nuxt_plugin_gtm_7e86d59a' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_portalvue_1617790f from 'nuxt_plugin_portalvue_1617790f' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_axios_593d6dc4 from 'nuxt_plugin_axios_593d6dc4' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_capiplugin_3462df4f from 'nuxt_plugin_capiplugin_3462df4f' // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_2e6fe8e8 from 'nuxt_plugin_errorpluginserver_2e6fe8e8' // Source: ../../@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_pluginsmsgBox0c7565b2_abc6f7f8 from 'nuxt_plugin_pluginsmsgBox0c7565b2_abc6f7f8' // Source: ./plugins.msgBox.0c7565b2.js (mode: 'all')
import nuxt_plugin_posthogclient_61b9b0c8 from 'nuxt_plugin_posthogclient_61b9b0c8' // Source: ../../../plugins/posthog.client.js (mode: 'client')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../../../plugins/axios.js (mode: 'all')
import nuxt_plugin_features_aa9d6138 from 'nuxt_plugin_features_aa9d6138' // Source: ../../../plugins/features.js (mode: 'all')
import nuxt_plugin_intl_5b870e44 from 'nuxt_plugin_intl_5b870e44' // Source: ../../../plugins/intl.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../../../plugins/i18n.js (mode: 'all')
import nuxt_plugin_intercomclient_7af5a0b9 from 'nuxt_plugin_intercomclient_7af5a0b9' // Source: ../../../plugins/intercom.client.js (mode: 'client')
import nuxt_plugin_page_922d665c from 'nuxt_plugin_page_922d665c' // Source: ../../../plugins/page.js (mode: 'all')
import nuxt_plugin_log_52e569ae from 'nuxt_plugin_log_52e569ae' // Source: ../../../plugins/log.js (mode: 'all')
import nuxt_plugin_visibility_fec94c22 from 'nuxt_plugin_visibility_fec94c22' // Source: ../../../plugins/visibility.js (mode: 'all')
import nuxt_plugin_contractbuildervalidator_7689747c from 'nuxt_plugin_contractbuildervalidator_7689747c' // Source: ../../../plugins/contract-builder-validator.js (mode: 'all')
import nuxt_plugin_contractbuilder_7b9e10e1 from 'nuxt_plugin_contractbuilder_7b9e10e1' // Source: ../../../plugins/contract-builder.js (mode: 'all')
import nuxt_plugin_tracker_605c9096 from 'nuxt_plugin_tracker_605c9096' // Source: ../../../plugins/tracker.js (mode: 'all')
import nuxt_plugin_notification_0f206214 from 'nuxt_plugin_notification_0f206214' // Source: ../../../plugins/notification.js (mode: 'all')
import nuxt_plugin_toaster_70c3bc59 from 'nuxt_plugin_toaster_70c3bc59' // Source: ../../../plugins/toaster.js (mode: 'all')
import nuxt_plugin_bugsnag_2200fd98 from 'nuxt_plugin_bugsnag_2200fd98' // Source: ../../../plugins/bugsnag.js (mode: 'all')
import nuxt_plugin_links_3a526914 from 'nuxt_plugin_links_3a526914' // Source: ../../../plugins/links.js (mode: 'all')
import nuxt_plugin_hiringclient_465c16c5 from 'nuxt_plugin_hiringclient_465c16c5' // Source: ../../../plugins/hiring.client.js (mode: 'client')
import nuxt_plugin_stripe_64a3c3d4 from 'nuxt_plugin_stripe_64a3c3d4' // Source: ../../../plugins/stripe.js (mode: 'all')
import nuxt_plugin_chargebeeclient_ab270b14 from 'nuxt_plugin_chargebeeclient_ab270b14' // Source: ../../../plugins/chargebee.client.js (mode: 'client')
import nuxt_plugin_country_4db5f297 from 'nuxt_plugin_country_4db5f297' // Source: ../../../plugins/country.js (mode: 'all')
import nuxt_plugin_storyblok_59553472 from 'nuxt_plugin_storyblok_59553472' // Source: ../../../plugins/storyblok.js (mode: 'all')
import nuxt_plugin_translate_195d385f from 'nuxt_plugin_translate_195d385f' // Source: ../../../plugins/translate.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Docue","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"script":[{"src":"https:\u002F\u002Fkit.fontawesome.com\u002F5a3cfb2dea.js","defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-T7Z7FXX')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"alternate icon","sizes":"16x16","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ffavicon.svg"},{"rel":"apple-touch-icon","href":"\u002Ffavicon-apple.png"},{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"preconnect","href":"https:\u002F\u002Fapi.docue.com"},{"rel":"preconnect","href":"https:\u002F\u002Fvc.hotjar.io","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fstatic.hotjar.com","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fscript.hotjar.com","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fvars.hotjar.com","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fin.hotjar.com","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fjs.stripe.com","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fm.stripe.com","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fm.stripe.network","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fwidget.intercom.io","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fjs.intercomcdn.com","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fapi-iam.intercom.io","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fkit-pro.fontawesome.com","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fconnect.facebook.net","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fwww.facebook.com","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fwww.google-analytics.com","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Fbat.bing.com","crossorigin":undefined},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":undefined},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Lexend:wght@300;400;500;600;700&family=Noto+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&family=Noto+Serif:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-T7Z7FXX&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6e56adae === 'function') {
    await nuxt_plugin_plugin_6e56adae(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_c903701a === 'function') {
    await nuxt_plugin_bootstrapvue_c903701a(app.context, inject)
  }

  if (typeof nuxt_plugin_appplugin_2375e480 === 'function') {
    await nuxt_plugin_appplugin_2375e480(app.context, inject)
  }

  if (typeof nuxt_plugin_configplugin_1e0439cf === 'function') {
    await nuxt_plugin_configplugin_1e0439cf(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin723a6a30_42d54637 === 'function') {
    await nuxt_plugin_libplugin723a6a30_42d54637(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_7e86d59a === 'function') {
    await nuxt_plugin_gtm_7e86d59a(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_1617790f === 'function') {
    await nuxt_plugin_portalvue_1617790f(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_593d6dc4 === 'function') {
    await nuxt_plugin_axios_593d6dc4(app.context, inject)
  }

  if (typeof nuxt_plugin_capiplugin_3462df4f === 'function') {
    await nuxt_plugin_capiplugin_3462df4f(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_errorpluginserver_2e6fe8e8 === 'function') {
    await nuxt_plugin_errorpluginserver_2e6fe8e8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsmsgBox0c7565b2_abc6f7f8 === 'function') {
    await nuxt_plugin_pluginsmsgBox0c7565b2_abc6f7f8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_posthogclient_61b9b0c8 === 'function') {
    await nuxt_plugin_posthogclient_61b9b0c8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_features_aa9d6138 === 'function') {
    await nuxt_plugin_features_aa9d6138(app.context, inject)
  }

  if (typeof nuxt_plugin_intl_5b870e44 === 'function') {
    await nuxt_plugin_intl_5b870e44(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intercomclient_7af5a0b9 === 'function') {
    await nuxt_plugin_intercomclient_7af5a0b9(app.context, inject)
  }

  if (typeof nuxt_plugin_page_922d665c === 'function') {
    await nuxt_plugin_page_922d665c(app.context, inject)
  }

  if (typeof nuxt_plugin_log_52e569ae === 'function') {
    await nuxt_plugin_log_52e569ae(app.context, inject)
  }

  if (typeof nuxt_plugin_visibility_fec94c22 === 'function') {
    await nuxt_plugin_visibility_fec94c22(app.context, inject)
  }

  if (typeof nuxt_plugin_contractbuildervalidator_7689747c === 'function') {
    await nuxt_plugin_contractbuildervalidator_7689747c(app.context, inject)
  }

  if (typeof nuxt_plugin_contractbuilder_7b9e10e1 === 'function') {
    await nuxt_plugin_contractbuilder_7b9e10e1(app.context, inject)
  }

  if (typeof nuxt_plugin_tracker_605c9096 === 'function') {
    await nuxt_plugin_tracker_605c9096(app.context, inject)
  }

  if (typeof nuxt_plugin_notification_0f206214 === 'function') {
    await nuxt_plugin_notification_0f206214(app.context, inject)
  }

  if (typeof nuxt_plugin_toaster_70c3bc59 === 'function') {
    await nuxt_plugin_toaster_70c3bc59(app.context, inject)
  }

  if (typeof nuxt_plugin_bugsnag_2200fd98 === 'function') {
    await nuxt_plugin_bugsnag_2200fd98(app.context, inject)
  }

  if (typeof nuxt_plugin_links_3a526914 === 'function') {
    await nuxt_plugin_links_3a526914(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hiringclient_465c16c5 === 'function') {
    await nuxt_plugin_hiringclient_465c16c5(app.context, inject)
  }

  if (typeof nuxt_plugin_stripe_64a3c3d4 === 'function') {
    await nuxt_plugin_stripe_64a3c3d4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chargebeeclient_ab270b14 === 'function') {
    await nuxt_plugin_chargebeeclient_ab270b14(app.context, inject)
  }

  if (typeof nuxt_plugin_country_4db5f297 === 'function') {
    await nuxt_plugin_country_4db5f297(app.context, inject)
  }

  if (typeof nuxt_plugin_storyblok_59553472 === 'function') {
    await nuxt_plugin_storyblok_59553472(app.context, inject)
  }

  if (typeof nuxt_plugin_translate_195d385f === 'function') {
    await nuxt_plugin_translate_195d385f(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
